import { render, staticRenderFns } from "./OrganizationRestrictedAccessPanel.vue?vue&type=template&id=3ff4d2ee&"
import script from "./OrganizationRestrictedAccessPanel.vue?vue&type=script&lang=js&"
export * from "./OrganizationRestrictedAccessPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports